"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatColumnOptions = formatColumnOptions;
// Generic helper function that infers the right option type based on column type
function formatColumnOptions(col, newOptions) {
    // For keyed object filters, set keyOptions instead of options.
    if (col.type === "numberObject" ||
        col.type === "stringObject" ||
        col.type === "booleanObject") {
        return { ...col, keyOptions: newOptions };
    }
    // For other types, set options
    return { ...col, options: newOptions };
}
